import type { FC, ReactNode } from 'react';
import { IpcFilterActions } from './IpcFilterActions';
import { IpcFilterChips, type IpcFilterChipItem } from './IpcFilterChips';
import { handleFilterTextBlur } from './ipcFilterTextCommit';

type Props = {
  children: ReactNode;
  /**
   * 重置：恢复页面默认筛选（draft + applied），并立即生效/请求。
   * 与 onClearChips（清空全部）语义不同，勿绑成同一个「清空」函数（除非该页默认即空）。
   * showActions=false 时可省略。
   */
  onReset?: () => void;
  /** 查询；showActions=false 时可省略 */
  onSubmit?: () => void;
  /** 是否展示「查询 / 重置」按钮，默认 true */
  showActions?: boolean;
  className?: string;
  extra?: ReactNode;
  /** 已应用筛选 chips（渲染在筛选行正下方） */
  chipItems?: IpcFilterChipItem[];
  onRemoveChip?: (key: string) => void;
  /**
   * 清除全部：去掉所有筛选值（不含默认），并立即生效/请求。
   * 与 onReset（恢复默认）不同。
   */
  onClearChips?: () => void;
};

export const IpcFilterToolbar: FC<Props> = ({
  children,
  onReset,
  onSubmit,
  showActions = true,
  className,
  extra,
  chipItems,
  onRemoveChip,
  onClearChips,
}) => (
  <div className="ipc-filter-section" onBlur={event => handleFilterTextBlur(event, onSubmit)}>
    <div className={['ipc-filter-bar', className].filter(Boolean).join(' ')}>
      {children}
      {showActions && onReset && onSubmit ? (
        <IpcFilterActions onReset={onReset} onSubmit={onSubmit} />
      ) : null}
      {extra != null && (
        <>
          <div className="ipc-filter-bar__spacer" />
          <div className="ipc-filter-bar__extra">{extra}</div>
        </>
      )}
    </div>
    {chipItems != null && onRemoveChip && onClearChips ? (
      <IpcFilterChips items={chipItems} onRemove={onRemoveChip} onClearAll={onClearChips} />
    ) : null}
  </div>
);
